export function isSearchingAny(searching) {
    return Object.values(searching).some((val) => val === true);
}

export function isSearchingAll(searching) {
    return Object.values(searching).every((val) => val === true);
}
